import { render } from "./CaseCardsView.vue?vue&type=template&id=23776200&ts=true"
import script from "./CaseCardsView.vue?vue&type=script&lang=ts"
export * from "./CaseCardsView.vue?vue&type=script&lang=ts"

import "./CaseCardsView.vue?vue&type=style&index=0&id=23776200&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__